{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40082-3",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "99c83de6-f7e9-43db-822d-baf0e8439805",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
      "nodeId": "ns=1;i=6163",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40082-3.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "190f9588-9101-4c4e-9e65-2361b493e9b9",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
      "nodeId": "ns=1;i=6193",
      "displayName": "Status",
      "variablePath": "Operation.Component_A.Status",
      "dataType": "Enum",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false,
      "enumValues": {
        "0": "GOOD",
        "1": "WARNING",
        "2": "WARNING_PRESSURE_TOO_HIGH",
        "3": "WARNING_PRESSURE_TOO_LOW",
        "4": "ADVANCE_WARNING_DRUM_CHANGE",
        "5": "ERROR_DRUM_EMPTY",
        "6": "ERROR"
      }
    },
    "colorValues": {
      "0": "#00ff00",
      "1": "#ffff00",
      "2": "#ffff00",
      "3": "#ffff00",
      "4": "#ffff00",
      "5": "#ff0000",
      "6": "#ff0000"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "9974283a-a790-43c4-90cc-92091fb27939",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
                "nodeId": "ns=1;i=6161",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "8b37a482-cfb6-4247-827a-420ee6bcccda",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
                "nodeId": "ns=1;i=6162",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "99c83de6-f7e9-43db-822d-baf0e8439805",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
                "nodeId": "ns=1;i=6163",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "65a147bd-508f-422d-b8e2-a09b22000abd",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
                "nodeId": "ns=1;i=6164",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Delivery Pressure",
              "valueVariable": {
                "id": "be8c5f74-1bbc-4611-9ad5-7f24b50a4766",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
                "nodeId": "ns=1;i=6244",
                "displayName": "ActualValue",
                "variablePath": "Operation.DeliveryPressure.ActualValue",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#ffffff",
                  "value": "0",
                  "label": "GOOD"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "1",
                  "label": "WARNING"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "2",
                  "label": "WARNING PRESSURE TOO HIGH"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "3",
                  "label": "WARNING PRESSURE TOO LOW"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "4",
                  "label": "ADVANCE WARNING DRUM CHANGE"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "5",
                  "label": "ERROR DRUM EMPTY"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "6",
                  "label": "ERROR"
                }
              ],
              "label": "Component A",
              "valueVariable": {
                "id": "190f9588-9101-4c4e-9e65-2361b493e9b9",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
                "nodeId": "ns=1;i=6193",
                "displayName": "Status",
                "variablePath": "Operation.Component_A.Status",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "GOOD",
                  "1": "WARNING",
                  "2": "WARNING_PRESSURE_TOO_HIGH",
                  "3": "WARNING_PRESSURE_TOO_LOW",
                  "4": "ADVANCE_WARNING_DRUM_CHANGE",
                  "5": "ERROR_DRUM_EMPTY",
                  "6": "ERROR"
                }
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#ffffff",
                  "value": "0",
                  "label": "GOOD"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "1",
                  "label": "WARNING"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "2",
                  "label": "WARNING PRESSURE TOO HIGH"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "3",
                  "label": "WARNING PRESSURE TOO LOW"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "4",
                  "label": "ADVANCE WARNING DRUM CHANGE"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "5",
                  "label": "ERROR DRUM EMPTY"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "6",
                  "label": "ERROR"
                }
              ],
              "label": "Component B",
              "valueVariable": {
                "id": "5aec2071-bd91-4054-a703-54b2ef983125",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/LDS/",
                "nodeId": "ns=1;i=6363",
                "displayName": "Status",
                "variablePath": "Operation.Component_B.Status",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "GOOD",
                  "1": "WARNING",
                  "2": "WARNING_PRESSURE_TOO_HIGH",
                  "3": "WARNING_PRESSURE_TOO_LOW",
                  "4": "ADVANCE_WARNING_DRUM_CHANGE",
                  "5": "ERROR_DRUM_EMPTY",
                  "6": "ERROR"
                }
              }
            }
          ]
        }
      ]
    }
  ]
}
